import { createSlice } from '@reduxjs/toolkit';
import { EnabledShippingTypesResponse_Data } from '../../../../pb/responses/v1/enabled_shipping_types_response_pb';
import { getEnabledShippingTypes } from './enabled-shipping-types.actions';

export interface EnabledShippingTypesState {
    enabledShippingTypes: EnabledShippingTypesResponse_Data[];
    loading: boolean;
}

const initialState: EnabledShippingTypesState = {
    enabledShippingTypes: [],
    loading: false,
};

const enabledShippingTypesSlice = createSlice({
    name: 'enabledShippingTypes',
    initialState,
    reducers: {
        setEnabledShippingTypes: (state, action) => {
            state.enabledShippingTypes = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getEnabledShippingTypes.fulfilled, (state, action) => {
            state.enabledShippingTypes = action.payload || [];
        });
        builder.addCase(getEnabledShippingTypes.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getEnabledShippingTypes.rejected, (state) => {
            state.loading = false;
        });
    },
});

export default enabledShippingTypesSlice.reducer;
